"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
exports.getInputBorderRadius = getInputBorderRadius;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _InputBase = _interopRequireDefault(require("./InputBase"));
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _HBTextField = require("../HBTextField/HBTextField.styles");
var _variables = require("../HBTextField/variables");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function getInputBorderRadius(borderRadius, inputSize) {
  var inputHeight = parseInt(_variables.INPUT_SIZE_PROPS.builder[inputSize].height, 10);
  var percentBorderRadius = borderRadius / 100;
  return percentBorderRadius * (inputHeight / 2);
}

/* Input extends from InputBase */
var Input = exports.Input = (0, _styledComponents["default"])(_InputBase["default"]).withConfig({
  displayName: "HBInputstyles__Input",
  componentId: "sc-hkef8y-0"
})(["&&{", " ", " ", " + span{margin-top:", ";}::-webkit-outer-spin-button,::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}}&[type='number']{-moz-appearance:textfield;}"], _HBTextField.textFieldBaseStyles, function (props) {
  return _variables.INPUT_SIZE_PROPS[props.scope][props.size];
}, function (props) {
  return props.readOnly && (0, _styledComponents.css)(["pointer-events:none;"]);
}, _spacing["default"][8]);
//# sourceMappingURL=HBInput.styles.js.map